import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class GlobalPaymentConformService {
  redirectToBank(GLOBAL_DATA: any): void {
    try {
      const { url, data } = GLOBAL_DATA || {};
      if (!url || !data) return console.warn('Redirect failed: Missing URL or form data');
      const form = Object.assign(document.createElement('form'), { method: 'post', action: url, id: 'GLOBAL_PAYMENT' });
      Object.entries(data).forEach(([name, value]) =>
        form.appendChild(Object.assign(document.createElement('input'), { type: 'hidden', name, value: value }))
      );
      document.body.appendChild(form);
      form.submit();
    } catch (error) {
      console.error('Redirect to bank failed:', error);
    }
  }
}
